import React, { lazy } from 'react';

const CompanyLogoForm = lazy(() =>
  import(
    'containers/SystemAdminModule/CompanyLogoModule/CompanyLogoForm'
  ).then(module => ({
    default: module.CompanyLogoForm,
  })),
);

const CompanyLogoDetail = lazy(() =>
  import(
    'containers/SystemAdminModule/CompanyLogoModule/CompanyLogoDetail'
  ).then(module => ({
    default: module.CompanyLogoDetail,
  })),
);

const companyLogoRoutes = [
  {
    props: { exact: true, path: '/:mode/general-settings/company-logo/edit' },
    component: <CompanyLogoForm />,
  },
  {
    props: { exact: true, path: '/:mode/general-settings/company-logo' },
    component: <CompanyLogoDetail />,
  },
];

export default companyLogoRoutes;
